import * as React from 'react'
import { stringNormalize, } from 'quill-string-normalizer'

import { DropdownInput, } from '../../index'

interface QuestionSearchProps {
  options: any[];
  onChange: ({ value }) => void;
  questionType?: string;
}

const stripHtmlAndSpecialCharactersFromPrompt = prompt => {
  return stringNormalize(prompt.replace(/(<([^>]+)>)/ig, '').replace(/&nbsp;/ig, ' ').replace(/&#x27;/g, '\u0027'))
}

export const QuestionSearch = ({ questionType, options, onChange, }: QuestionSearchProps) => {
  let formattedOptions

  if (questionType === 'titleCards') {
    formattedOptions = options.map((opt: { key: string, title: string }) => {
      return { label: stringNormalize(opt.title), value: opt.key }
    });
  } else {
    formattedOptions = options.map((opt: { key: string, prompt: string } )=> {
      return { label: opt.prompt ? stripHtmlAndSpecialCharactersFromPrompt(opt.prompt) : 'No name', value: opt.key, };
    });
  }

  return (
    <DropdownInput
      className="questions-search-input"
      handleChange={onChange}
      id="all-questions"
      isSearchable={true}
      label="All Questions"
      options={formattedOptions}
      persistInputValue={true}
      placeholder="Search for a question"
    />
  )
}
